export const CODE_TIME_OUT_REQUEST = "ECONNABORTED";

export const CODE_BAD_REQUEST = 400;

export const CODE_FORBIDDEN = 403;